import React, { ReactElement, useEffect, useState } from "react";

import { Resolution } from "../../components/card/card-box";
import Dropdown from "../../components/dropdown/dropdown";
import { Asset } from "../../generated/gql/graphql";
import useAssets from "../../hooks/query/asset/use-assets";
import { useDirectus } from "../../providers/DirectusProvider";
import AssetService from "../../services/asset";

type Props = {
  asset: Asset;
};

export default function StackVersionSelector(props: Props): ReactElement {
  const { asset } = props;

  const [stackVersions, setStackVersions] = useState<Asset[]>([]);
  const [type, setType] = useState<string | undefined>();
  const [resolution, setResolution] = useState<Resolution>();

  const { directus } = useDirectus();
  const { getFileType } = AssetService(directus);

  const { data, loading, error } = useAssets({
    filter: {
      parentId: {
        eq: asset.id,
      },
    },
    // orderBy: [
    //     {
    //         oder_index: Sort.Desc
    //     }
    // ],
  });

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!data || !data.assets) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setStackVersions(data.assets.items);
  }, [data]);

  useEffect(() => {
    (async (): Promise<void> => {
      if (!asset.image) {
        return;
      }

      const file = await getFileType(asset.image);

      setType(file?.type);
      setResolution({
        width: file?.width ?? 0,
        height: file?.height ?? 0,
      });
      // setStackVersions((await getAssetStackVersions(asset.id)) ?? []);
    })();
  }, []);

  return (
    <Dropdown
      stackVersions={stackVersions}
      setStackVersions={setStackVersions}
      asset={asset}
      fileType={type}
      resolution={resolution}
      classes="mt-6 absolute right-20 top-[65px] p-1 bg-white rounded-[25px] z-1"
    />
  );
}
